import React from 'react';
import {PrimaryButton, TextDetail} from "../components/UIkit";
import {useDispatch} from "react-redux";
import {push} from "connected-react-router";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    detailBox: {
        margin: '0 auto',
        [theme.breakpoints.down('sm')]: {
            width: 320
        },
        [theme.breakpoints.up('md')]: {
            width: 512
        },
    },
    orderBox: {
        border: '1px solid rgba(0,0,0,0.2)',
        borderRadius: 4,
        boxShadow: '0 4px 2px 2px rgba(0,0,0,0.2)',
        height: 226,
        margin: '24px auto 16px auto',
        padding: 16,
        width: 288
    },
    box: {
        border: '1px solid rgba(0,0,0,0.2)',
        borderRadius: 4,
        boxShadow: '0 4px 2px 2px rgba(0,0,0,0.2)',
        margin: '24px auto 16px auto',
        padding: 16,
        width: 288,
        textAlign: "left"
    },
}));

const OrderComplete = () => {
    const dispatch = useDispatch()
    const classes = useStyles();
    // const goBackToTop = useCallback(() => {
    //     dispatch(push('/'))
    // }, [])

    return (
        <div className="c-section-container">
            <p>ご注文ありがとうございました！</p>
            <div className={classes.box}>
                <p>植栽工事をご希望の場合以外は、現地渡しとなります。銀行振り込み後にお願いします。</p>
                <p>お振込みは一週間以内にお願いします。</p>
                <p>お振込み後は一か月以内にお越しください。</p>
                <p>配送をご希望は相談に応じます。</p>
            </div>
            <div className={classes.orderBox}>
                <TextDetail label={"銀行名"} value={"北陸銀行"} />
                <TextDetail label={"支店名"} value={"太閤山支店"} />
                <TextDetail label={"種類"} value={"普通"} />
                <TextDetail label={"口座番号"} value={"6062146"} />
                <TextDetail label={"名前"} value={"アライズ"} />
            </div>
            <div className="module-spacer--medium" />
            <PrimaryButton label="ショッピングを続ける" onClick={() => dispatch(push('/'))} />
        </div>
    );
};

export default OrderComplete;